/* 🤖 this file was generated by svg-to-ts */
export const DfIconToolsSquare16: {
  name: 'tools-square-16';
  data: string;
} = {
  name: 'tools-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM9.001 4.143 9 6.5l-.008.09A.5.5 0 0 1 8.5 7h-1l-.09-.008A.5.5 0 0 1 7 6.5V4.142c-1.165.344-2 1.27-2 2.358s.835 2.014 2 2.358V11.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5l.001-2.643C10.166 8.514 11 7.588 11 6.5s-.834-2.014-1.999-2.357z"/></svg>`
};
